"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin } from "lucide-react";
export default function TheRsvpLegacy() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-rsvp-legacy" className="relative overflow-hidden bg-background py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[22vw] font-bold text-foreground opacity-5 select-none pointer-events-none whitespace-nowrap z-0 tracking-tighter" aria-hidden="true">
        LEGACY
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          {}
          <div ref={contentRef} className={`lg:col-span-8 space-y-10 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-serif tracking-tight">
                The RSVP Legacy
              </h2>
              <div className="w-24 h-1.5 bg-primary rounded-full"></div>
            </div>

            <div className="columns-1 md:columns-2 gap-10 text-muted-foreground leading-relaxed text-lg">
              <p className="break-inside-avoid mb-6">
                Business Tantra operates as the specialized trademark commercialization arm of RSVP Enterprises. Founded on the principle of unlocking hidden value in intellectual property, our mission is to bridge the gap between visionary entrepreneurs and premium, ready-to-launch brand assets.
              </p>
              <p className="break-inside-avoid mb-6">
                We recognized that the traditional 6–12 month timeline for brand naming and legal clearance was a significant bottleneck for fast-moving businesses. By curating a high-potential portfolio of legally verified trademarks, we empower startups and established enterprises to bypass these hurdles.
              </p>
              <p className="break-inside-avoid">
                Our vision extends beyond simple transactions; we act as a trusted intermediary, structuring acquisitions that provide immediate market entry and long-term brand security. We transform underutilized registered trademarks into powerful catalysts for business expansion across diverse industries.
              </p>
            </div>
          </div>

          {}
          <div ref={cardRef} className={`lg:col-span-4 transition-all duration-1000 delay-300 ease-out ${isCardVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Card className="border-2 border-primary bg-card/90 backdrop-blur-md shadow-2xl relative overflow-hidden rounded-none md:rounded-xl">
              {}
              <div className="absolute -top-12 -right-12 w-32 h-32 bg-primary/10 rounded-full blur-2xl pointer-events-none"></div>
              
              <CardHeader className="pb-2">
                <CardTitle className="flex items-center gap-2 text-primary uppercase tracking-widest text-xs font-bold">
                  <MapPin className="w-4 h-4" />
                  Quick Fact
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-3xl md:text-4xl font-serif font-medium text-foreground leading-tight">
                  Delhi-based,<br />
                  <span className="text-muted-foreground text-2xl md:text-3xl mt-2 block">Pan-India Execution.</span>
                </p>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}